import UploadImg from "./uploadImg";
export default UploadImg;



// WEBPACK FOOTER //
// ./src/model/uploadImg/index.js